import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';


const Circle = () => {

    return (
      <div style = {{textAlign: 'center', paddingTop: 20}}>
        <CircularProgress size={80} thickness={5} />
      </div>
    )
};

export default Circle;


// WEBPACK FOOTER //
// ./src/sys/Circle.jsx